import {Component} from '@angular/core';

@Component({
    selector: 'svg-halfchecked',
    template: `
        <svg class="svg-halfchecked" version="1.1" id="Слой_1" xmlns="http://www.w3.org/2000/svg" 
             xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 565.4 565.4" style="enable-background:new 0 0 565.4 565.4;" xml:space="preserve">
            <rect x="131.3" y="124.5" width="311.3" height="311.3"/>
            <path d="M501.5,0H63.9C28.6,0,0,28.6,0,63.9v437.5c0,35.3,28.6,63.9,63.9,63.9h437.5c35.3,0,63.9-28.6,63.9-63.9V63.9
                C565.4,28.6,536.8,0,501.5,0z M486.3,481.3H80.8V75.7h405.5V481.3z"/>
        </svg>
    `
})

export class SvgHalfCheckedComponent {

}



// WEBPACK FOOTER //
// /app/src/app/components/svg/halfchecked.component.ts